import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSelect,{attrs:{"id":"ad-select","item-text":"nome","item-name":"usuarioId","item-value":"usuarioId","items":_vm.users,"label":"Analista","placeholder":"Analista"},model:{value:(_vm.filter.analistaId),callback:function ($$v) {_vm.$set(_vm.filter, "analistaId", $$v)},expression:"filter.analistaId"}},[_c('template',{slot:"no-data"},[_vm._v("\n    Nenhum Analista retornado\n  ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }